
import React from 'react';

import {Dialog} from './Dialog';

import * as styles from './styles.module.scss';

export const Assistant = () => (
	<div className={styles.wrapper}>
		<h4>Have a specific question?</h4>
		<Dialog />
	</div>
);
